module.exports = __webpack_public_path__ + "media/images/icons/2people-6508473a82f696c8139dfaab0135adf8.svg";